// NoMunch buy box: add to cart via AJAX and open the cart drawer, instead of the
// native form POST that navigates to the /cart page. Sends the selling plan explicitly
// (items[].selling_plan) so subscriptions attach reliably, then dispatches
// CartLinesUpdateEvent(action:'add') so the drawer auto-opens and all cart UI refreshes.
import { CartLinesUpdateEvent } from '@shopify/events';

const DRAWER_SECTION = 'cart-drawer-section';

function root() {
  return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
}
function addUrl() {
  return `${root()}cart/add.js`;
}
function cartUrl() {
  return `${root()}cart.js`;
}

document.addEventListener('submit', (event) => {
  const form = event.target;
  if (!(form instanceof HTMLFormElement) || !form.classList.contains('nm-bb-form')) return;
  event.preventDefault();

  const submitter = event.submitter instanceof HTMLElement ? event.submitter : null;
  if (submitter) submitter.setAttribute('aria-busy', 'true');
  const clearBusy = () => { if (submitter) submitter.removeAttribute('aria-busy'); };

  const idInput = form.querySelector('[name="id"]');
  const qtyInput = form.querySelector('[name="quantity"]');
  const planInput = form.querySelector('[name="selling_plan"]');
  const merchandiseId = idInput ? idInput.value : null;
  const quantity = Number(qtyInput && qtyInput.value) || 1;
  const sellingPlan = planInput && planInput.value ? planInput.value : null;

  const sectionIds = new Set([DRAWER_SECTION]);
  document.querySelectorAll('cart-items-component').forEach((el) => {
    if (el instanceof HTMLElement && el.dataset.sectionId) sectionIds.add(el.dataset.sectionId);
  });

  const line = { id: merchandiseId, quantity };
  if (sellingPlan) line.selling_plan = sellingPlan;

  const deferred = CartLinesUpdateEvent.createPromise();
  form.dispatchEvent(
    new CartLinesUpdateEvent({
      action: 'add',
      context: 'product',
      lines: [{ merchandiseId, quantity }],
      promise: deferred.promise,
    })
  );

  fetch(addUrl(), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({
      items: [line],
      sections: Array.from(sectionIds).join(','),
      sections_url: window.location.pathname,
    }),
  })
    .then((r) => r.json())
    .then((response) => {
      if (response.status) {
        console.error('[nm-add-to-cart] add failed:', response.description || response.message, response);
        deferred.reject(new Error(response.description || response.message || 'Add to cart failed'));
        clearBusy();
        return;
      }
      // Open the cart drawer explicitly (don't rely on the auto_open_cart_drawer setting)
      var drawer = document.getElementById('cart-drawer');
      if (drawer && typeof drawer.open === 'function') drawer.open();
      fetch(cartUrl(), { headers: { Accept: 'application/json' } })
        .then((r) => r.json())
        .then((cart) => {
          deferred.resolve({
            cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
            detail: {
              items: cart.items,
              source: 'nm-buy-box',
              itemCount: quantity,
              sections: response.sections,
            },
          });
        })
        .finally(clearBusy);
    })
    .catch((error) => {
      console.error('[nm-add-to-cart]', error);
      clearBusy();
    });
});
